import React from 'react';
import styled from 'styled-components';
import { Body5 } from '@ui';
import { VAULT_DENSITIES, VAULT_VIEW_MODES } from '@utils/documentVault';
import { DocumentVaultFilterContext } from '@/contexts/DocumentVaultFilterContext';

const ControlsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;

const SegmentedWrapper = styled.div`
  display: flex;
  flex-direction: row;

  border: 1px solid ${({ theme }) => theme.themeColors.border};
  border-radius: 4px;
  overflow: hidden;
`;

const Segment = styled.button`
  padding: 4px 10px;
  cursor: pointer;
  white-space: nowrap;

  border: none;
  font: inherit;

  background: ${({ theme, $isActive }) => ($isActive ? theme.themeColors.primaryCtaButton : 'transparent')};

  * {
    color: ${({ theme, $isActive }) => ($isActive ? theme.themeColors.buttonText : theme.themeColors.text)};
  }
`;

const Segmented = ({ options, value, onChange, ariaLabel }) => (
  <SegmentedWrapper role="group" aria-label={ariaLabel}>
    {options.map((option) => (
      <Segment
        key={option.value}
        type="button"
        aria-pressed={value === option.value}
        $isActive={value === option.value}
        onClick={() => onChange(option.value)}
      >
        <Body5>{option.label}</Body5>
      </Segment>
    ))}
  </SegmentedWrapper>
);

const VIEW_OPTIONS = [
  { value: VAULT_VIEW_MODES.table, label: 'Table' },
  { value: VAULT_VIEW_MODES.tree, label: 'Tree' },
];

const DENSITY_OPTIONS = [
  { value: VAULT_DENSITIES.comfortable, label: 'Comfortable' },
  { value: VAULT_DENSITIES.compact, label: 'Compact' },
];

export const VaultViewControls = () => {
  const { filters, setViewMode, setDensity } = React.useContext(DocumentVaultFilterContext);

  return (
    <ControlsWrapper>
      <Segmented options={VIEW_OPTIONS} value={filters.viewMode} onChange={setViewMode} ariaLabel="View mode" />
      <Segmented options={DENSITY_OPTIONS} value={filters.density} onChange={setDensity} ariaLabel="Row density" />
    </ControlsWrapper>
  );
};
